import { createApi } from '@reduxjs/toolkit/dist/query/react';
import axiosBaseQuery from '../../service/shared/axiosBaseQuery';
import { ControlUnitAPIResponse } from '../../service/controlUnit/ControlUnit.model';
import { toBase64 } from '../../shared/util/base64';

export interface ControlUnitQueryArg {
  deviceId: string;
  commanderId: string;
}

export interface ControlUnitQueryResponse {
  id: string;
  controlunits: ControlUnitAPIResponse[];
}

const ControlUnitAPI = createApi({
  reducerPath: 'controlUnitAPI',
  baseQuery: axiosBaseQuery({ baseUrl: 'commander/' }),
  endpoints(build) {
    return {
      getControlUnitsByDevice: build.query<
        ControlUnitQueryResponse,
        ControlUnitQueryArg
      >({
        query: ({ commanderId }) => ({
          url: `${toBase64(commanderId)}/controlunits`,
        }),
        transformResponse: (
          response: ControlUnitAPIResponse[],
          _meta,
          arg
        ) => ({
          id: arg.deviceId,
          controlunits: response,
        }),
      }),
    };
  },
});

export default ControlUnitAPI;
